import { render, staticRenderFns } from "./LinkPayTaahodat.vue?vue&type=template&id=03f34672&scoped=true&"
import script from "./LinkPayTaahodat.vue?vue&type=script&lang=js&"
export * from "./LinkPayTaahodat.vue?vue&type=script&lang=js&"
import style0 from "./LinkPayTaahodat.vue?vue&type=style&index=0&id=03f34672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f34672",
  null
  
)

export default component.exports